/**
 * Strips the option prefix (e.g., "A. ", "B. ") from option text.
 * This is used to avoid duplicate prefixes when displaying options,
 * since we add our own prefixes in the UI.
 *
 * @param text - The option text that may contain a prefix
 * @returns The text with the prefix removed
 *
 * @example
 * stripOptionPrefix("A. Mefenamic acid") // "Mefenamic acid"
 * stripOptionPrefix("Mefenamic acid") // "Mefenamic acid"
 */
export function stripOptionPrefix(text: string): string {
  return text.replace(/^[A-Za-z]\.\s+/, "")
}

const MEDIA_SELECTOR = "img, picture, svg, video, audio, iframe, object, embed"

/**
 * Whether rich-text HTML renders anything: visible text or embedded media.
 * Editor leftovers such as "<p></p>", "<p><br></p>" or "&nbsp;" count as
 * empty; an image-only fragment does not. DOMParser documents are inert, so
 * parsing loads no images and runs no scripts.
 */
export function hasHtmlContent(html: string | null | undefined): boolean {
  if (!html?.trim()) return false
  const { body } = new DOMParser().parseFromString(html, "text/html")
  return (
    Boolean(body.textContent?.trim()) ||
    body.querySelector(MEDIA_SELECTOR) !== null
  )
}
